import { computed } from 'vue'

import {
  usePlatformLanguages,
  usePropertyDescriptionFields,
} from '@/components/propertyDetails/propertyDescriptions/queries'

export const DESCRIPTION_SOURCE = {
  HOTELIER: 'HOTELIER',
  TRIVAGO: 'TRIVAGO',
}

const RTL_LANGUAGE_CODES = new Set(['ar', 'he'])

export function usePropertyDescriptions() {
  const { simplifiedPlatformLanguages, isPlatformLanguagesLoading, isPlatformLanguagesError } = usePlatformLanguages()
  const { propertyDescriptions, isPropertyDescriptionsLoading, isPropertyDescriptionsError } =
    usePropertyDescriptionFields()

  const hasDescriptions = computed(() => propertyDescriptions.value.length > 0)

  const existingLanguageCodes = computed(() => new Set(propertyDescriptions.value.map(d => d.languageCode)))

  const availableLanguages = computed(() =>
    simplifiedPlatformLanguages.value.filter(lang => !existingLanguageCodes.value.has(lang.language))
  )

  const getLanguageByCode = languageCode =>
    simplifiedPlatformLanguages.value.find(language => language.language === languageCode)
  const getLanguageLabelByCode = languageCode => getLanguageByCode(languageCode)?.translatedLabel ?? languageCode
  const getDescriptionTextDirection = languageCode => (RTL_LANGUAGE_CODES.has(languageCode) ? 'rtl' : 'ltr')

  return {
    descriptions: propertyDescriptions,
    hasDescriptions,
    availableLanguages,
    getLanguageByCode,
    getLanguageLabelByCode,
    getDescriptionTextDirection,
    isDescriptionsLoading: computed(() => isPropertyDescriptionsLoading.value || isPlatformLanguagesLoading.value),
    isDescriptionsError: computed(() => isPropertyDescriptionsError.value || isPlatformLanguagesError.value),
  }
}
